/* ==========================================================================
   Pawlymate — theme scripts
   Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var settings = window.themeSettings || {};
  var strings = window.themeStrings || {};
  var routes = settings.routes || {};

  /* ---------------------------------------------------------------- utils */

  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || settings.moneyFormat || '${{amount}}';

    function defaultTo(num, size) {
      var s = '000000000' + num;
      return s.substr(s.length - size);
    }

    function thousands(number, precision, thousandSep, decimalSep) {
      thousandSep = thousandSep === undefined ? ',' : thousandSep;
      decimalSep = decimalSep === undefined ? '.' : decimalSep;
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandSep);
      var cts = parts[1] ? decimalSep + parts[1] : '';
      return dollars + cts;
    }

    var match = fmt.match(placeholderRegex);
    switch (match && match[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function trapFocus(container) {
    var focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    first.focus();
    return function () { container.removeEventListener('keydown', handler); };
  }

  function lockScroll(lock) {
    document.body.classList.toggle('no-scroll', !!lock);
  }

  var toastTimer;
  function showToast(message) {
    var toast = $('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 2600);
  }

  /* --------------------------------------------------------------- header */

  function initHeader() {
    var header = $('.header');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------------------------------------------------------- generic modal */

  function initDrawers() {
    var releaseFocus = null;
    var lastTrigger = null;

    function open(target) {
      var el = document.getElementById(target);
      if (!el) return;
      el.hidden = false;
      lockScroll(true);
      releaseFocus = trapFocus(el);
    }

    function closeAll() {
      $$('[data-drawer]').forEach(function (el) { el.hidden = true; });
      var cart = $('#CartDrawer');
      if (cart) cart.hidden = true;
      lockScroll(false);
      if (releaseFocus) { releaseFocus(); releaseFocus = null; }
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        lastTrigger = opener;
        open(opener.getAttribute('data-drawer-open'));
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-drawer-overlay')) {
        e.preventDefault();
        closeAll();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    window.themeCloseDrawers = closeAll;
  }

  /* ----------------------------------------------------------- cart drawer */

  function renderCartDrawer(cart) {
    var body = $('[data-cart-drawer-body]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="empty-state">' +
        '<p class="h4">' + (strings.cartEmpty || 'Your cart is empty') + '</p>' +
        '<a class="button mt-2" href="' + (routes.cart_url || '/cart') + '">' + (strings.viewCart || 'View cart') + '</a>' +
        '</div>';
      return;
    }

    var html = '<div class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_200x$1$2') : null;
      html += '<div class="cart-item">' +
        '<div class="cart-item__image">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="72" height="72">' : '') +
        '</div>' +
        '<div>' +
        '<a class="cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
        '<div class="cart-item__variant">' + item.quantity + ' &times; ' + formatMoney(item.final_price) + '</div>' +
        '</div>' +
        '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    });
    html += '</div>';

    html += '<div class="mt-3">' +
      '<div class="flex-between" style="font-weight:700;font-size:1.1rem">' +
      '<span>' + (strings.subtotal || 'Subtotal') + '</span>' +
      '<span>' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="cart-summary__note">' + (strings.taxNote || 'Taxes and shipping calculated at checkout.') + '</p>' +
      '<a class="button button--full" href="/checkout">' + (strings.checkout || 'Checkout') + '</a>' +
      '<a class="button button--soft button--full mt-1" href="' + (routes.cart_url || '/cart') + '">' + (strings.viewCart || 'View cart') + '</a>' +
      '</div>';

    body.innerHTML = html;
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCart(openDrawer) {
    return fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderCartDrawer(cart);
        if (openDrawer) {
          var drawer = $('#CartDrawer');
          if (drawer) { drawer.hidden = false; lockScroll(true); }
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }

  function initAjaxCart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) {
        var drawer = $('#CartDrawer');
        if (drawer) drawer.hidden = true;
        lockScroll(false);
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-product-form]')) return;
      if (!settings.cartAjax) return;

      e.preventDefault();
      var button = form.querySelector('[data-add-button]');
      var original = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.innerHTML = '…'; }

      fetch(routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            showToast(res.data.description || res.data.message || 'Error');
            return;
          }
          showToast(strings.addedToCart || 'Added to your cart');
          return refreshCart(true);
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (button) { button.disabled = false; button.innerHTML = original; }
        });
    });
  }

  /* ------------------------------------------------------ quantity inputs */

  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('.quantity-selector');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-change'), 10);
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------ cart page */

  function initCartPage() {
    var page = $('[data-cart-page]');
    if (!page) return;

    function change(line, quantity) {
      page.style.opacity = '.5';
      fetch(routes.cart_change_url ? routes.cart_change_url + '.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      change(parseInt(input.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
    });

    page.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      change(parseInt(remove.getAttribute('data-line'), 10), 0);
    });
  }

  /* ------------------------------------------------------ free shipping bar */

  function initShippingBar() {
    var bars = $$('[data-shipping-bar]');
    if (!bars.length) return;

    function update(total) {
      var threshold = parseFloat(settings.cartFreeShipping || '0') * 100;
      if (!threshold) return;
      bars.forEach(function (bar) {
        var fill = bar.querySelector('[data-shipping-fill]');
        var text = bar.querySelector('[data-shipping-text]');
        var pct = Math.min(100, (total / threshold) * 100);
        if (fill) fill.style.width = pct + '%';
        if (text) {
          text.textContent = total >= threshold
            ? (strings.freeShippingUnlocked || 'Free shipping unlocked!')
            : (strings.freeShippingProgress || '').replace('[amount]', formatMoney(threshold - total));
        }
      });
    }

    var initial = bars[0].getAttribute('data-cart-total');
    if (initial) update(parseInt(initial, 10));
    document.addEventListener('cart:updated', function (e) { update(e.detail.total_price); });
  }

  /* -------------------------------------------------------- variant picker */

  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var dataEl = document.getElementById('VariantData-' + sectionId);
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var form = document.getElementById('ProductForm-' + sectionId);
      var idInput = form && form.querySelector('[data-variant-id]');
      var priceEl = document.getElementById('Price-' + sectionId);
      var addButton = form && form.querySelector('[data-add-button]');
      var addButtonText = addButton && addButton.querySelector('[data-add-text]');
      var skuEl = document.getElementById('Sku-' + sectionId);

      function selectedOptions() {
        return $$('input[type="radio"]:checked, select[data-option-select]', picker).map(function (el) {
          return el.value;
        });
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === opts[i]; });
        });
      }

      function updateAvailability(current) {
        // Mark option values that produce no available variant
        $$('.option', picker).forEach(function (optionGroup, groupIndex) {
          $$('input[type="radio"]', optionGroup).forEach(function (input) {
            var trial = selectedOptions().slice();
            trial[groupIndex] = input.value;
            var match = variants.find(function (v) {
              return v.options.every(function (opt, i) {
                return i === groupIndex ? opt === input.value : opt === trial[i];
              });
            });
            var label = optionGroup.querySelector('label[for="' + input.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
        if (current) {
          $$('[data-option-current]', picker).forEach(function (el, i) {
            el.textContent = current.options[i];
          });
        }
      }

      function update() {
        var opts = selectedOptions();
        var variant = findVariant(opts);

        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            if (addButtonText) addButtonText.textContent = strings.unavailable || 'Unavailable';
          }
          updateAvailability(null);
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) {
          var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
          priceEl.classList.toggle('price--on-sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
        }

        if (skuEl) skuEl.textContent = variant.sku || '';

        if (addButton) {
          addButton.disabled = !variant.available;
          if (addButtonText) {
            addButtonText.textContent = variant.available
              ? (strings.addToCart || 'Add to cart')
              : (strings.soldOut || 'Sold out');
          }
        }

        // Swap gallery image
        if (variant.featured_media && variant.featured_media.id) {
          var slide = document.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
          if (slide) selectMedia(slide.getAttribute('data-media-id'), sectionId);
        }

        // Keep URL in sync
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }

        updateAvailability(variant);
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ------------------------------------------------------- product gallery */

  function selectMedia(mediaId, sectionId) {
    $$('[data-gallery="' + sectionId + '"] .product__gallery-slide').forEach(function (slide) {
      slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === String(mediaId));
    });
    $$('[data-thumbs="' + sectionId + '"] .product__thumb').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
    });
  }

  function initGallery() {
    $$('[data-thumbs]').forEach(function (thumbs) {
      var sectionId = thumbs.getAttribute('data-thumbs');
      thumbs.addEventListener('click', function (e) {
        var thumb = e.target.closest('.product__thumb');
        if (!thumb) return;
        selectMedia(thumb.getAttribute('data-media-id'), sectionId);
      });
    });
  }

  /* ---------------------------------------------------------- announcement */

  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var speed = parseInt(bar.getAttribute('data-speed') || '5', 10) * 1000;
    var index = 0;
    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, speed);
  }

  /* ----------------------------------------------------------- collection */

  function initCollectionSort() {
    var select = $('[data-sort-by]');
    if (!select) return;
    on(select, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    $$('[data-facet-form]').forEach(function (form) {
      form.addEventListener('change', function () {
        var params = new URLSearchParams(new FormData(form));
        var url = new URL(window.location.href);
        url.search = params.toString();
        window.location.href = url.toString();
      });
    });
  }

  /* -------------------------------------------------------- reveal on scroll */

  function initReveal() {
    var els = $$('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ share link */

  function initShare() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('data-share') || window.location.href;
      if (navigator.share) {
        navigator.share({ url: url, title: document.title }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          showToast(btn.getAttribute('data-copied') || 'Link copied');
        });
      }
    });
  }

  /* ----------------------------------------------------------------- boot */

  function init() {
    initHeader();
    initDrawers();
    initAjaxCart();
    initQuantity();
    initCartPage();
    initShippingBar();
    initVariantPickers();
    initGallery();
    initAnnouncement();
    initCollectionSort();
    initReveal();
    initShare();
    if (settings.cartAjax) refreshCart(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', function () {
    initVariantPickers();
    initGallery();
    initAnnouncement();
    initReveal();
    initShippingBar();
  });
})();
